<div v-if= 'visible_domain && token_exists' class="card border-0 bg-transparent d-none d-xl-block " >
    <h6 class="card-header bg-transparent text-muted">Businesses</h6>
    <div v-for="profile in filtered_business" >
        <div class="d-flex align-items-center p-0" @click="view_profile(profile)">
              <img src="@/assets/images/briefcase.png" class="w-20px" alt="">
              <p class="text-xs mt-3 ms-1 fw-500">{{profile.company_name}}</p>
          <div>   
          </div>
        </div>
      </div>
      <div v-if="business_profiles.length > visibleCount" class="overflow-auto p-3 full-width-mobile scroll-container mt-2">
        <a class="btn btn-sm btn-transparent text-secondary" href="/view_business_profiles">
        
          <i v-if="showAll" class="bx bxs-up-arrow-circle ms-2"></i> 
          <i v-if="!showAll" class="bx bxs-down-arrow-circle ms-2"></i>
      
          {{ showAll ? 'See Less' : 'See More' }}
        </a>
      </div>
  </div>
  
  
  
  